import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import * as Component from './SearchHeader.styles'

import Bookmark from './partials/Bookmark/Bookmark'
import { Icon } from 'components/atoms'
import { TextContext } from 'hocs'
import { useHistory } from 'react-router'
import { getPlainComparePath } from 'settings/app/urlHelpers'
import { useSelector } from 'react-redux'
import { entryPointId, PAGE_TYPES } from 'settings/app/constants'

const SearchHeader = (props) => {
  const {
    headerImage,
    headerHeadline,
    headerText,
    title,
    searchBar,
    bookmarkCount,
    onBookmarkButtonClicked,
    showCompareButton,
  } = props

  const textContext = useContext(TextContext)
  const entryPoint = useSelector((state) => state.application.entryPoint)
  const history = useHistory()
  let showHeaderImage = headerImage

  // on pageType resultPage do not render image (only on startPage && seoPage)
  if (localStorage.getItem('pageType') === PAGE_TYPES.RESULT_PAGE) {
    showHeaderImage = false
  }

  return (
    <>
      {showHeaderImage && (
        <div id='search-header'>
          <Component.HeaderImage imgSrc={ headerImage }>
            <Component.HeaderText>
              <Component.HeadlineWrapper>
                {headerHeadline}
              </Component.HeadlineWrapper>
              <Component.TextWrapper>{headerText}</Component.TextWrapper>
            </Component.HeaderText>
          </Component.HeaderImage>
        </div>
      )}

      <Component.SearchBarContainer id='search-bar'>
        {!showHeaderImage && (
          <Component.SearchBarHeader>
            <h4 className='h4'>{title}</h4>
            {entryPoint !== entryPointId.MIDWIVES &&
              entryPoint !== entryPointId.AMBULANCES &&
              entryPoint !== entryPointId.ONCALLSERVICES &&
              entryPoint !== entryPointId.CARESUPPORT && (
                <div className='header-menu'>
                  <Bookmark
                    count={ bookmarkCount }
                    onBookmarkButtonClicked={ onBookmarkButtonClicked }
                    data-cy='searchbar-bookmark'
                  />
                  {showCompareButton && (
                    <Component.CompareButton
                      id='compare-btn'
                      data-cy='bookmark-compare-btn'
                      text={ textContext['general.compare.Link'] }
                      onClick={ () =>
                        history.push(getPlainComparePath(entryPoint, 'local'))
                      }
                      icon={ <Icon className='icon-f-compare' /> }
                    />
                  )}
                </div>
              )}
          </Component.SearchBarHeader>
        )}
        <Component.SearchBar hasImage={ showHeaderImage }>
          {searchBar}
        </Component.SearchBar>
      </Component.SearchBarContainer>
    </>
  )
}

SearchHeader.defaultProps = {
  bookmarkCount: 0,
  showCompareButton: false,
  headerImage: false,
}

SearchHeader.propTypes = {
  /** optional header background image source */
  headerImage: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  /** optional header headline */
  headerHeadline: PropTypes.string,
  /** optional header text */
  headerText: PropTypes.string,

  /** Number of bookmarks */
  bookmarkCount: PropTypes.number,
  /**
   * Bookmark button clicked
   * Signature: function(e: Event) {...}
   */
  onBookmarkButtonClicked: (props, propName) => {
    if (
      props.headerImage === undefined &&
      (props[propName] === undefined || typeof props[propName] !== 'function')
    ) {
      return new Error('Please provide a onBookmarkButtonClicked function!')
    }
  },
  /** Header title */
  title: PropTypes.string,
  /** SearchBar Component */
  searchBar: PropTypes.element,
  /** Compare Button Click Handler */
  showCompareButton: PropTypes.bool,
}

export default SearchHeader
